import styles from "./styles/measurement-table.module.css";
import { Image } from "./Image";
import { Description } from "./Description";

function TableBody({ measurementValues, units }) {
    const numberOfMeasurements = measurementValues[0].length - 1;
    const listItemElements = [];
    const html = '';
    for (let row = 1; row <= numberOfMeasurements; row++) {
        const rowHtml = `<tr>`;
        for( let column = 0; column < measurementValues.length; column++) {
            rowHtml += `<td style="${column === 0 ? 'position:sticky;left:0;border: 1px solid var(--color-light-gray);z-index:2;background:white' :''}" key=${column}>${measurementValues[column][row]}${column == 0 ? '' : units}</td>`;
        }
        rowHtml += `</tr>`;
        html += rowHtml;
    }
    return (
        <tbody dangerouslySetInnerHTML={{__html: html}} /> 
    );
}

export function MeasurementsTable({ title, data, image, units, type, description }) {
    return (
        <>
            <h4 className={styles.title}>{title}</h4>
            <div className={styles.measurementTableWrapper}>
                <table className={styles.measurementTable}>
                    <thead>
                        <tr>
                            {data.map((measurementNames, idx) => {
                                if (idx === 0) {
                                    return (<><td className={idx === 0 ? styles.fixed : styles.right}>Size</td></>);
                                }
                                return (<td>{measurementNames[0]}</td>);
                            })}
                        </tr>
                    </thead>
                    <TableBody measurementValues={data} units={units} />
                </table>
            </div>
            <div className={styles.imageWrapper}>
                <Image data={image} />
            </div>
            <Description description={description} />
        </>
    )
}